import { createContext } from 'react';
import colors from 'colors.json';

const ProductColorContext = createContext<string>(colors.primary.default);

export default ProductColorContext;
